module.exports = __webpack_public_path__ + "img/MCAP.4828c3a5.svg";